import { useGlobalStateContext } from "@/context/GlobalContext";

/**
 * Custom hook to get the userType state from global context
 * This hook provides a convenient way to access the userType
 * that is automatically computed based on userDetails.type
 * 
 * @returns {string} userType - User type as uppercase string (e.g., 'VENDOR', 'TJ', etc.)
 */
export const useUserType = (): string => {
  const { userType } = useGlobalStateContext();
  return userType;
};

